import React, { useEffect, useMemo, useState } from "react";
import { MonitorGridStrings, SearchItem } from "./types";

interface QuickSearchBarProps {
  searchItems: SearchItem[];
  qtype: string;
  query: string;
  busy: boolean;
  visible: boolean;
  gridStrings?: MonitorGridStrings;
  onSearch: (payload: { qtype: string; query: string; qdesc: string }) => void;
  onClear: () => void;
}

function selectedLabel(searchItems: SearchItem[], value: string): string {
  const selected = searchItems.find((item) => item.value === value);
  return selected ? selected.label : "";
}

export default function QuickSearchBar(props: QuickSearchBarProps) {
  const { searchItems, qtype, query, busy, visible, gridStrings, onSearch, onClear } = props;
  const fallbackType = useMemo(() => (searchItems.length > 0 ? searchItems[0].value : "patient*name"), [searchItems]);

  const [localQuery, setLocalQuery] = useState(query || "");
  const [localQtype, setLocalQtype] = useState(qtype || fallbackType);

  useEffect(() => {
    setLocalQuery(query || "");
  }, [query]);

  useEffect(() => {
    setLocalQtype(qtype || fallbackType);
  }, [qtype, fallbackType]);

  const submit = (event?: React.FormEvent) => {
    if (event) {
      event.preventDefault();
    }

    const normalizedType = localQtype || fallbackType;
    onSearch({
      qtype: normalizedType,
      query: localQuery,
      qdesc: selectedLabel(searchItems, normalizedType)
    });
  };

  const strings = gridStrings || ({} as MonitorGridStrings);
  const searchLabel = strings.search_label || "Quick Search";
  const searchButton = strings.search_button || "Search";
  const clearButton = strings.clear_button || "Clear";

  return (
    <div className="sDiv" style={{ display: visible ? "block" : "none" }}>
      <div className="sDiv2">
        <form onSubmit={submit}>
          <label htmlFor="monitor-react-quick-search-input" style={{ marginRight: 6 }}>
            {searchLabel}
          </label>
          <input
            id="monitor-react-quick-search-input"
            className="qsbox"
            type="text"
            value={localQuery}
            onChange={(event) => setLocalQuery(event.target.value)}
          />
          <select
            className="qsType"
            value={localQtype}
            onChange={(event) => setLocalQtype(event.target.value)}
          >
            {searchItems.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          <button type="submit" className="btn btn-success btn-sm" disabled={busy}>
            {searchButton}
          </button>
          <button
            type="button"
            className="btn btn-success btn-sm"
            disabled={busy}
            onClick={() => {
              setLocalQuery("");
              onClear();
            }}
          >
            {clearButton}
          </button>
        </form>
      </div>
    </div>
  );
}
